import { render, staticRenderFns } from "./InsightsList.vue?vue&type=template&id=dfa190a0"
import script from "./InsightsList.vue?vue&type=script&lang=js"
export * from "./InsightsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports